/**
 * The Accounts screen's words for a caller the sync is not offered to — in place of the
 * button, so the screen says why there is none instead of answering «forbidden» after a
 * press (audits/2026-10-20/spa-review.md item 5).
 */
export const SYNC_ADMIN_ONLY =
	"Pulling accounts from X is a platform admin's action: the console refuses it to every other role. What is listed here is the last sync — a platform admin can pull a refresh.";

/*
 * The page's description and its empty sentence, for the same caller. Both told every
 * reader to pull a refresh — an action the screen offers to a platform admin alone — so
 * a caller without the button reads who pulls instead of being told to (-98's 🔵 on W6;
 * the same form as ttads a98a403).
 */
export const ABOUT_NOT_ADMIN =
	"Read from the console's own database, not from X on every load. A platform admin pulls a refresh when accounts change in X Ads Manager.";

export const EMPTY_NOT_ADMIN =
	"Nothing synced yet. Once X Ads API access is approved and credentials are configured, a platform admin can pull a refresh, and the accounts those credentials can reach will be listed.";
